"use client";

import { loginAction, LoginActionState } from "@entities/auth";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Button, Input, Label } from "@pandawa-qfast-core/react-ui-kit";
import { LoaderIcon, MailIcon, LockIcon } from "lucide-react";
import Link from "next/link";
import { useActionState } from "react";

const loginActionInitialState: LoginActionState = {
  success: false,
  message: "",
  errors: {},
  fields: {
    email: "",
  },
};

export function LoginForm() {
  const [state, formAction, pending] = useActionState(loginAction, loginActionInitialState);

  return (
    <form action={formAction} className="space-y-5">
      {state.message && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm flex items-start gap-2.5 fade-in-top">
          <InformationCircleIcon className="h-5 w-5 mt-0.5 flex-shrink-0 text-red-400" />
          <span>{state.message}</span>
        </div>
      )}

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email" className="text-sm font-medium text-foreground">
            Email
          </Label>
          <div className="relative">
            <MailIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
            <Input
              id="email"
              type="email"
              name="email"
              placeholder="nama@email.com"
              disabled={pending}
              defaultValue={state.fields?.email}
              className="pl-10 h-11"
            />
          </div>
          {state.errors?.email && <p className="text-xs text-red-500 mt-1">{state.errors.email[0]}</p>}
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="text-sm font-medium text-foreground">
              Password
            </Label>
            <Link
              href="/forgot-password"
              className="text-sm font-medium text-tertiary hover:text-tertiary-600 transition-colors"
              tabIndex={-1}
            >
              Lupa password?
            </Link>
          </div>
          <div className="relative">
            <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
            <Input
              id="password"
              name="password"
              type="password"
              placeholder="Masukkan password"
              disabled={pending}
              className="pl-10 h-11"
            />
          </div>
          {state.errors?.password && <p className="text-xs text-red-500 mt-1">{state.errors.password[0]}</p>}
        </div>
      </div>

      <Button
        type="submit"
        className="w-full h-11 font-bold text-sm bg-primary hover:bg-primary-600 transition-colors shadow-sm"
        disabled={pending}
      >
        {pending ? (
          <>
            <LoaderIcon className="mr-2 h-4 w-4 animate-spin" />
            Sedang masuk...
          </>
        ) : (
          "Masuk"
        )}
      </Button>
    </form>
  );
}
